import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import isString from 'lodash/isString';
import isObject from 'lodash/isObject';
import { FormattedMessage } from 'react-intl';
import MuiSnackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';
import { showSnackbar, hideSnackbar } from 'actions';

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

class SnackbarClass extends React.Component {
  handleClose = (e, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    this.props.hideSnackbar();
  };

  render() {
    const { snackbar } = this.props;
    const { open, severity, message } = snackbar;

    return (
      <>
        <MuiSnackbar
          open={open}
          autoHideDuration={4000}
          onClose={this.handleClose}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        >
          <Alert onClose={this.handleClose} severity={severity}>
            {isString(message) && <>{message}</>}
            {isObject(message) && (
              <FormattedMessage
                id={message.id}
                defaultMessage={message.defaultMessage}
                values={message.values || {}}
              />
            )}
          </Alert>
        </MuiSnackbar>
      </>
    );
  }
}

SnackbarClass.propTypes = {
  hideSnackbar: PropTypes.func.isRequired,
  snackbar: PropTypes.shape({
    open: PropTypes.bool,
    severity: PropTypes.oneOf(['success', 'warning', 'info', 'error']),
    message: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.shape({
        id: PropTypes.string.isRequired,
        defaultMessage: PropTypes.string.isRequired,
        values: PropTypes.object,
      }),
    ]),
  }).isRequired,
};

const mapStateToProps = (state) => ({
  snackbar: state.ui.snackbar,
});

const mapDispatchToProps = (dispatch) => ({
  showSnackbar: (config) => dispatch(showSnackbar(config)),
  hideSnackbar: () => dispatch(hideSnackbar()),
});

export default connect(mapStateToProps, mapDispatchToProps)(SnackbarClass);
